import { controls, grouped } from "../controls";
const rbi_mis_nos = {
  label: "Rbi Mis Nos",
  pageLabel: "Rbi Mis Nos", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "RBI State Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "state_code_RBI", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "State" }),
    ...controls.oc({ tab: "filter", c: "State", placeHolder: "State Code", name: "RBIMISCode-state-state_code", fastpath: "states" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "RBIMISCode-state-state_display" }),
    ...controls.displayText({ tab: "filter", label: "District Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "district_code_RBI", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "District" }),
    ...controls.oc({ tab: "filter", c: "District", placeHolder: "District Code", name: "RBIMISCode-district-district_code", fastpath: "districts" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "RBIMISCode-district-district_display" }),
    ...controls.displayText({ tab: "filter", label: "BLOCK Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "block_code", maxlength: 10 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Region" }),
    ...controls.oc({ tab: "filter", c: "Region", placeHolder: "Region Code", name: "RBIMISCode-region-region_code", fastpath: "regions" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "RBIMISCode-region-region_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "RBI State Code", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "state_code_RBI", isRequired: true, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "State", star: false }),
    ...controls.oc({ tab: "general", c: "State", placeHolder: "State Code", name: "state_code", isRequired: false, fastpath: "states" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "state_display" }),
    ...controls.displayText({ tab: "general", label: "District Code", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "district_code_RBI", isRequired: true, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "District", star: false }),
    ...controls.oc({ tab: "general", c: "District", placeHolder: "District Code", name: "district_code", isRequired: false, fastpath: "districts" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "district_display" }),
    ...controls.displayText({ tab: "general", label: "BLOCK Code", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "block_code", isRequired: true, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "general", label: "Taluka", star: true }),
    ...controls.text({ tab: "general", placeHolder: "", name: "taluka_code", isRequired: true, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "general", label: "Region", star: false }),
    ...controls.oc({ tab: "general", c: "Region", placeHolder: "Region Code", name: "region_code", isRequired: false, fastpath: "regions" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "region_display" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Rbi Mis Nos",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "RBI State Code", accessor: "state_code_RBI", },
      { Header: "State Id", accessor: "state_id", },
      { Header: "District Code", accessor: "district_code_RBI", },
      { Header: "District Id", accessor: "district_id", },
      { Header: "BLOCK Code", accessor: "block_code", },
      { Header: "Region Id", accessor: "region_id", },
      { Header: "Taluka", accessor: "RBIMISCode-region-region_display", },

    ]
  }
};
export default rbi_mis_nos;